import React, { ReactNode } from "react";
import { SelectProps, Select, MenuItem, MenuItemProps, InputLabel } from "@mui/material";
import ListSubheader from "@mui/material/ListSubheader";
import { WcFormControl, WcFormHelperText } from "../../misc";

export type WcSelectProps = SelectProps & {
  controlDisabled?: boolean;
  useFullWidth?: boolean;
  children: ReactNode;
  helperText?: string;
};

export type WcMenuItemProps = MenuItemProps & {
  sx?;
};

export const WcSelect = ({ useFullWidth, controlDisabled, label, children, sx, ...others }: WcSelectProps) => (
  <Select
    id="WcSelect"
    disabled={controlDisabled}
    label={label}
    fullWidth={useFullWidth ? true : false}
    sx={[...(Array.isArray(sx) ? sx : [sx])]}
    {...others}
  >
    {children}
  </Select>
);

export const WcSelectFormControl = ({
  // size = "small",
  useFullWidth = false,
  controlDisabled,
  label,
  children,
  helperText,
  sx,
  ...others
}: WcSelectProps) => (
  <WcFormControl fullWidth={useFullWidth ? true : false}>
    <InputLabel id="WcSelectLabel">{label}</InputLabel>
    <Select
      labelId="WcSelectLabel"
      id="WcSelectFormControl"
      disabled={controlDisabled}
      label={label}
      fullWidth={useFullWidth ? true : false}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      {...others}
    >
      {children}
    </Select>
    {helperText && <WcFormHelperText>{helperText}</WcFormHelperText>}
  </WcFormControl>
);

export const WcMenuItem = ({ sx, children, value, disabled, onClick, ...others }: WcMenuItemProps) => (
  <MenuItem sx={[...(Array.isArray(sx) ? sx : [sx])]} value={value} disabled={disabled} onClick={onClick} {...others}>
    {children}
  </MenuItem>
);

export const WcSelectGroupHeader = ListSubheader;

export default WcSelect;
